<template>
  <div class="companyRange">
    <el-dialog
      title="请选择投标人范围"
      :visible.sync="isShowVisible"
      width="50vw"
      center
      class="companyRangePopupStyle"
      :close-on-click-modal="false"
      :before-close="() => $emit('close')">
      <el-checkbox-group v-model="values">
        <el-checkbox-button v-for="item in companyList" :label="item.id" :key="item.id">{{ item.name }}</el-checkbox-button>
      </el-checkbox-group>
      <div slot="footer">
        <el-button type="info" @click="closeModal" class="btnHeight_40 btWith_120">取消</el-button>
        <el-button type="primary" @click="selectWorkTypes" class="btnHeight_40 btWith_120">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCompanyByLetter } from '@api/public'
export default {
  name: 'companyRange',
  props: ['List', 'objectsList'],
  data () {
    return {
      isShowVisible: true,
      values: [],
      companyList: []
    }
  },
  mounted () {
    this.getCompanyByLetter()
    this.values = this.List
  },
  methods: {
    getCompanyByLetter () {
      const data = {}
      const objectsList = []
      for (var i = 0; i < this.objectsList.length; i++) {
        if (objectsList.indexOf(this.objectsList[i]) === -1) {
          objectsList.push(this.objectsList[i])
        }
      }
      data.objects = objectsList.join(',') // 派活对象
      getCompanyByLetter(data).then(res => {
        if (res.data.code === 200) {
          const List = res.data.data
          this.companyList = []
          List.forEach(item => {
            if (item.list && item.list.length > 0) {
              item.list.map(val => {
                this.companyList = this.companyList.concat(val)
              })
            }
          })
        } else {
          this.message.error(res.data.msg)
        }
      })
    },
    closeModal () {
      this.values = []
      this.$emit('close')
    },
    selectWorkTypes () {
      if (this.values.length < 3) {
        this.$message.error('请至少选择3个队伍')
      } else {
        this.$emit('companyValues', this.values)
        this.closeModal()
      }
    }
  }
}
</script>

<style lang="scss">
  .companyRangePopupStyle{
    .el-checkbox-button__inner{
      min-width: 150px;
      margin-bottom: 12px;
    }
    .el-checkbox-button.is-checked .el-checkbox-button__inner{
      background-color: #FCB040;
      border-color: #FCB040;
    }
  }
</style>
